

export const formatDate = (date, reportType, month) => {
  if (reportType === "Day") {
    return date;
  } else {
    // Convert date and month to numbers to remove any leading zeros
    const numericDay = +date;
    const numericMonth = +month;
    const formattedDate = numericDay + "." + numericMonth;
    return formattedDate;
  }
};

export const getUniqueValueNames = (data, selectedGroup = null) => {
  if (!data || data.length === 0) { return []; }
  const valueNamesSet = new Set();
  data.forEach((item) => {
    if (selectedGroup && item.SubReports && item.SubReports[selectedGroup]) {
      // Only get value names from the selected group
      item.SubReports[selectedGroup].forEach((singleSubReport) => {
        valueNamesSet.add(singleSubReport.ValueName);
      });
    } else if (!selectedGroup) {
      // If no group selected, get from all groups (backward compatibility)
      const subReportsObjectToArray = Object.values(item.SubReports);
      subReportsObjectToArray.forEach((singleSubReportArray) => {
        singleSubReportArray.forEach((singleSubReport) => {
          valueNamesSet.add(singleSubReport.ValueName);
        });
      });
    }
  });
  return Array.from(valueNamesSet);
};

export const getUniqueMeasurementUnitNames = (data, selectedGroup = null) => {
  if (!data || data.length === 0) { return []; }
  const unitNamesSet = new Set();
  data.forEach((item) => {
    if (selectedGroup && item.SubReports && item.SubReports[selectedGroup]) {
      // Only get unit names from the selected group
      item.SubReports[selectedGroup].forEach((singleSubReport) => {
        unitNamesSet.add(singleSubReport.Unit);
      });
    } else if (!selectedGroup) {
      // If no group selected, get from all groups (backward compatibility)
      const subReportsObjectToArray = Object.values(item.SubReports);
      subReportsObjectToArray.forEach((singleSubReportArray) => {
        singleSubReportArray.forEach((singleSubReport) => {
          unitNamesSet.add(singleSubReport.Unit);
        });
      });
    }
  });
  return Array.from(unitNamesSet);
};
